export const Report = {
  CREATE: 'CREATE_REPORT',
  OVERRIDE: 'OVERRIDE_REPORTS',
  REMOVE: 'REMOVE_REPORT',
  UPDATE: 'UPDATE_REPORT',
};

export const Table = {
  SET_COLUMN: 'SET_TABLE_COLUMN',
  SET: 'SET_TABLE',
};

export const Column = {
  Add: 'ADD_DATABASE_COLUMN',
  Remove: 'REMOVE_DATABASE_COLUMN',
};

export const User = {
  CREATE: 'CREATE_USER',
  OVERRIDE: 'OVERRIDE_USERS',
  REMOVE: 'REMOVE_USER',
  UPDATE: 'UPDATE_USER',
};
